import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useRestartAvisoObraFieldsConfig from './useRestartAvisoObraFieldsConfig';
import useFormValidation from '../../../hooks/useFormValidation';

export interface RestartAvisoObraFormData {
    restartDate: string;
    endDate: string;
}

export const INITIAL_VALUES: RestartAvisoObraFormData = {
    restartDate: '',
    endDate: ''
};

const useRestartAvisoObraForm = (selectedObra: any) => {
    const [formData, setFormData] = useState<RestartAvisoObraFormData>(INITIAL_VALUES);
    const { t } = useTranslation('avisoObra');

    const { errors, hasValidationErrors, validateForm, handleBlurValidation, setErrors } =
        useFormValidation();

    const { fieldsConfig } = useRestartAvisoObraFieldsConfig({
        t,
        formData,
        handleBlurValidation,
        selectedObra
    });

    const handleChange = (name: string, value: any) => {
        setErrors((prevState) => ({
            ...prevState,
            [name]: { hasError: false, errorMessage: '' }
        }));
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const resetForm = () => {
        setFormData(INITIAL_VALUES);
        setErrors({});
    };

    return {
        formData,
        errors,
        hasValidationErrors,
        fieldsConfig,
        handleChange,
        validateForm,
        resetForm
    };
};
export default useRestartAvisoObraForm;
